import {
  USER_FETCH_REQUESTED,
  USER_FETCH_SUCCEEDED,
  USER_FETCH_FAILED,
  USER_ACCESS_CHECK_FAILED,
  USER_ACCESS_CHECK_SUCCEEDED,
} from '../actionTypes'
import { Action } from '../actions'

const initialState = {
  user: {},
  message: '',
  isAccessAuthorized: false,
}

// Assign the arrow function to a named constant
const userReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case USER_FETCH_REQUESTED: {
      return {
        ...state,
      }
    }
    case USER_FETCH_SUCCEEDED: {
      const { user } = action.payload
      return {
        ...state,
        user: user,
      }
    }
    case USER_FETCH_FAILED: {
      const { message } = action.payload
      return {
        ...state,
        message: message,
      }
    }
    case USER_ACCESS_CHECK_SUCCEEDED: {
      return {
        ...state,
        isAccessAuthorized: true,
      }
    }
    case USER_ACCESS_CHECK_FAILED: {
      return {
        ...state,
        isAccessAuthorized: false,
      }
    }
    default:
      return state
  }
}

// Export the named constant as the default export
export default userReducer
